import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
    ExpertDatasetSelectionDTO,
    ExpertDatasetUsageType,
} from '../models/expert-data';

@Injectable({
    providedIn: 'root',
})
export class ExpertDatasetService {
    readonly restUrl: string;

    constructor(private http: HttpClient) {
        this.restUrl = environment.backendUrl + '/rest/expert-dataset/training';
    }

    getExpertDataById(trainingId: string) {
        const url = `${this.restUrl}/${trainingId}/expertDataSelection`;
        return this.http.get<ExpertDatasetSelectionDTO>(url);
    }

    saveExpertDataSelection(
        trainingId: string,
        datasetName: string,
        usageType: ExpertDatasetUsageType
    ) {
        const url = `${this.restUrl}/${trainingId}/expertDataSelection`;
        return this.http.post(url, {
            datasetName: datasetName,
            usageType: usageType,
        });
    }
}
